import { FC, ReactNode, RefObject, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
    children: ReactNode;
    elementRef?: RefObject<HTMLElement>;
}

function createPortalNode() {
    const node = document.createElement('div');
    node.dataset.portal = 'true';

    return node;
}

export const Portal: FC<PortalProps> = ({ children, elementRef }) => {
    const [mounted, setMounted] = useState(false);
    const nodeRef = useRef<HTMLElement>();

    useEffect(() => {
        setMounted(true);
        nodeRef.current = elementRef?.current || createPortalNode();

        if (!elementRef && nodeRef.current) {
            document.body.append(nodeRef.current);
        }

        return () => {
            if (!elementRef && nodeRef.current) {
                nodeRef.current.remove();
            }
        };
    }, []);

    if (!mounted || !nodeRef.current) {
        return null;
    }

    return createPortal(<>{children}</>, nodeRef.current);
};
